import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";
import FinanceProfile from "./FinanceProfile";
import DailySalaryProfile from "./DailySalaryProfile";
import BenefitProfile from "./_benefit_profile/BenefitProfile";
import ContractsProfile from "./_contract-profile/ContractsProfile";
import InfoProfile from "./InfoProfile";
import LibraryProfile from "./LibraryProfile";

const Routes = (props) => {
  const basePath = "/mis";
  const { tid } = props.match.params;
  const search = props.location.search || "";

  return (
    <Switch>
      <Route
        path={`${basePath}/teachers/:tid/profile/info`}
        render={(p) => <InfoProfile {...p} />}
      />
      <Route
        path={`${basePath}/teachers/:tid/profile/salary`}
        render={(p) => <FinanceProfile {...p} />}
      />
      <Route
        path={`${basePath}/teachers/:tid/profile/daily-salary`}
        render={(p) => <DailySalaryProfile {...p} />}
      />
      <Route
        path={`${basePath}/teachers/:tid/profile/library`}
        render={(p) => <LibraryProfile {...p} />}
      />
      <Route
        path={`${basePath}/teachers/:tid/profile/benefit`}
        render={(p) => <BenefitProfile {...p} />}
      />
      <Route
        path={`${basePath}/teachers/:tid/profile/contracts`}
        render={(p) => <ContractsProfile {...p} />}
      />
      <Redirect to={`/mis/teachers/${tid}/profile/info${search}`} />
    </Switch>
  );
};

export default Routes;
